import { render, staticRenderFns } from "./me.vue?vue&type=template&id=3c54204d&scoped=true"
import script from "./me.vue?vue&type=script&lang=js"
export * from "./me.vue?vue&type=script&lang=js"
import style0 from "./me.vue?vue&type=style&index=0&id=3c54204d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c54204d",
  null
  
)

export default component.exports